import { isEmpty, join, reject, trim } from 'lodash/fp';

export default (data = {}, isTwoLines, showCounty) => {
  const { streetAddress, apartment, city, county, state, zipCode } = data;
  const addressLine = apartment
    ? `${streetAddress} #${apartment}`
    : streetAddress;

  const arrAddress = showCounty ? [city, county || '', state] : [city, state];
  const cityCountyState = join(', ', reject(isEmpty, arrAddress));

  if (isTwoLines)
    return {
      line1: trim(addressLine),
      line2: trim(`${cityCountyState} ${zipCode || ''}`)
    };

  return `${addressLine}, ${cityCountyState} ${zipCode || ''}`;
};
